<template>
    <card class="form-horizontal">
        <div class="card-header">
            <h6 class="card-title text-center">
                Push evaluación
            </h6>
        </div>
        <div class="card-body">
            <div class="form-group">
                <label>Texto de evaluación </label>
                <textarea   class="form-control"
                            tabindex="6"
                            type="text"
                            name="descripcion"
                            autocomplete="off"
                            placeholder="Agregue el texto de la evaluación"
                            :error="getError('descripcion')"
                            v-model="assessmentText">
                </textarea>
            </div>
        </div>
        <div class="card-footer">
            <div class="text-right">
                <p-button @click="pushAssessment()" type="warning">Siguiente</p-button>
                <p-button @click="toIndex()" type="default" class="pull-left mb-3">Atrás</p-button>
            </div>
        </div>
    </card>
</template>
    <script>
    import { Card } from 'src/components/UIComponents'
    import Vue from 'vue'
    import {Select, Option} from 'element-ui'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import moment from 'moment'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
import { parse } from 'expression-eval'
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            VueNumeric,
            PSwitch,
        },
        data() {
        return {
            
            assessmentText: '',
        }
        },
        watch: {
            
        },
        computed: {
            
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toIndex () {
                this.$router.push('/');
            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
                console.info(this.errors)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            pushAssessment () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        var payload = {
                            assessment: this.assessmentText
                        };
                        this.$store.dispatch('pushAssessment', payload).then(()=>{
                            this.$router.push('/admin/finished_evaluations');
                        });
                    }
                    else {
                        this.showNotificationError('Error escribiendo');
                    }
                })
                
                
            }
        },
        mounted() {
            
        }
    }
</script>
<style>
</style>
